import React from "react"
import { Box, useMediaQuery, useTheme } from "@material-ui/core"
import ResourceViewer from "./resource-viewer/resource-viewer"
import useStore from "src/v2/utils/store"
import FileViewer from "./file-viewer/file-viewer"

export default function FormalMapping() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const oneReview = useStore((state) => state.oneReview)
  const solFiles = oneReview?.analyzedData?.solFiles || []
  const initialFile = oneReview?.mainFileName || (solFiles[0]?.path || "")

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      width="100%"
      height="100%"
      minHeight={isMobile ? 600 : 400}
    >
      <Box
        flex={isMobile ? "unset" : 1}
        width={isMobile ? "100%" : "50%"}
        minWidth={isMobile ? "100%" : 0}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ResourceViewer />
      </Box>
      <Box
        flex={isMobile ? "unset" : 1}
        width={isMobile ? "100%" : "50%"}
        minWidth={isMobile ? "100%" : 0}
        style={{
          background: "#f6f6fa",
          minHeight: 300,
        }}
      >
        <FileViewer solFiles={solFiles} initialFile={initialFile} />
      </Box>
    </Box>
  )
}